__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-06-1770378920-stable-dev/";